module.exports = __webpack_public_path__ + "static/media/hw_hi_27.09b56fe3.flv";